export enum TransportContractDocumentType {
  HOUSE_WAYBILL = 'HOUSE_WAYBILL', // code is 703
  MASTER_BILL_OF_LADING = 'MASTER_BILL_OF_LADING', // code is 704
  HOUSE_BILL_OF_LADING = 'HOUSE_BILL_OF_LADING', // code is 714
}
